import {
  Box, Menu, MenuItem, Button,
} from '@mui/material';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SyntheticEvent, useState } from 'react';
import { useUserContext } from '../contexts/UserContext';
import LogoutModal from './logoutModal';

interface Props {
  name: string
  hasMenu: boolean
}

export const MyMenu = (props: Props) => {
  const { name, hasMenu } = props;

  const [myOptionsAnchor, setMyOptionsAnchor] = useState(null);
  const myOptionsOpen = Boolean(myOptionsAnchor);

  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const { logoutUser } = useUserContext();

  const handleMyOptionsClose = () => {
    setMyOptionsAnchor(null);
  };

  const handleMyOptionsClicked = (e: SyntheticEvent) => {
    if (!hasMenu) {
      return;
    }
    setMyOptionsAnchor(e.target);
  };

  return (
    <div className="navbar-collapse collapse">
      <ul className="navbar-nav navbar-align">
        <li className="nav-item dropdown">
          <Box>
            <Button
              onClick={handleMyOptionsClicked}
              startIcon={<FontAwesomeIcon icon={faUser} />}
              disableRipple
              style={{ cursor: 'pointer' }}
              sx={{ '&:hover': { backgroundColor: 'transparent' }, textTransform: 'none' }}
            >
              {name}
            </Button>
          </Box>

          <Menu
            style={{ zIndex: 10 }}
            id="basic-menu"
            anchorEl={myOptionsAnchor}
            open={myOptionsOpen}
            onClose={handleMyOptionsClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem sx={{ height: '1.8rem', paddingLeft: 0, paddingRight: 0 }} onClick={() => setLogoutModalOpen(true)}>
              <a className="dropdown-item" href="#">
                <i className="fa-solid fa-door-open fa-fw" />
                {' '}
                ログアウト
              </a>
            </MenuItem>
            <LogoutModal
              open={logoutModalOpen}
              handleClose={() => setLogoutModalOpen(false)}
              handleSave={() => {
                logoutUser();
                setLogoutModalOpen(false);
              }}
            />
          </Menu>

        </li>
      </ul>
    </div>
  );
};
